import axios from 'axios';
import store from '@/store';

const baseURL = process.env.VUE_APP_BASE_URL_SERVER || "http://localhost/rest";

console.log('baseURL', baseURL);

export default () => {
    return axios.create({
        baseURL: baseURL,
        headers: {
            Authorization: `Bearer ${store.state.token}`,
        },
    });
};
